import styled from "styled-components";
import { Box, BoxProps } from "rebass";

interface ILI extends BoxProps {
  isActive?: boolean;
}

export const LI = styled(Box)<ILI>`
  position: relative;
  padding: 8px 9px 8px 17px;
  background-color: ${({ isActive, theme }) => isActive ? theme.colors["sp-gray2"] : "transparent"};
  transition: all .4s ease-in-out;
`;

LI.defaultProps = {
  as: "li"
};
